import React , { useContext }from "react";
import PropTypes from "prop-types";
import { formValueSelector } from "redux-form";
import { useSelector } from "react-redux";
import { StringField, ComboBoxField, DateField, RadioButtonsFlat, CheckboxField } from "cxa-form-field";
import { getValidations } from "../validations";
import Section from "./Section";
import Grid from "./Grid";
import EmailField from "./Email";
import NumberField from "./Number";
import PhoneField from "./Phone";
import Question from "./Question";
import Questions from "./Questions";
import FemaleSection from "./FemaleSection";
import MedicalHistory from "./MedicalHistory";
import DependantParticulars from "./DependantParticulars";
import { HdfDataContext } from "../index";

const HDFComponent = ({ label, name, comp, prefix, ...props }) => {
  const valueSelector = formValueSelector("GeneralHDF");
  const state = useSelector(state => state);
  const isReadOnly = useContext(HdfDataContext).isCompleted || false;
  const comName = prefix ? `${prefix}_${comp.id}` : comp.id;

  if (comp.conditional) {
    const conditionalFieldName = prefix
      ? `${prefix}_${comp.conditional.when}`
      : comp.conditional.when;
    const conditionalValue = valueSelector(state, conditionalFieldName);
    if (conditionalValue != comp.conditional.eq || !comp.conditional.show) {
      return "";
    }
  }
  switch (comp.type) {
    case "text":
      return (
        <StringField
          id={name || comName}
          name={name || comName}
          label={comp.label}
          disabled={isReadOnly || comp.readOnly}
          validate={[...getValidations(comp.validation)]}
        />
      );
    case "number":
      return (
        <NumberField
          id={name || comName}
          name={name || comName}
          label={comp.label}
          disabled={isReadOnly || comp.readOnly}
          validate={[...getValidations(comp.validation)]}
        />
      );
    case "phone":
      return (
        <PhoneField
          id={name || comName}
          name={name || comName}
          label={comp.label}
          disabled={isReadOnly || comp.readOnly}
          validate={[...getValidations(comp.validation)]}
        />
      );
    case "email":
      return (
        <EmailField
          id={name || comName}
          name={name || comName}
          label={comp.label}
          disabled={isReadOnly || comp.readOnly}
          validate={[...getValidations(comp.validation)]}
        />
      );
    case "list":
      return (
        <ComboBoxField
          id={name || comName}
          name={name || comName}
          label={comp.label}
          disabled={isReadOnly || comp.readOnly}
          items={comp.options}
          validate={[...getValidations(comp.validation)]}
          {...props}
        />
      );
    case "radio":
      return (
        <RadioButtonsFlat
          id={name || comName}
          name={name || comName}
          label={label || comp.label}
          items={comp.options}
          disabled={isReadOnly || comp.readOnly}
          validate={[...getValidations(comp.validation)]}
          inline={true}
        />
      );
    case "date":
      return (
        <DateField
          id={name || comName}
          name={name || comName}
          label={comp.label}
          disabled={isReadOnly || comp.readOnly}
          validate={[...getValidations(comp.validation)]}
        />
      );
    case "checkbox":
      return (
        <CheckboxField
          id={name || comName}
          name={name || comName}
          disabled={isReadOnly || comp.readOnly}
          validate={[...getValidations(comp.validation)]}
        >
          {comp.label}
        </CheckboxField>
      );
    case "section":
      return <Section {...comp} {...props} />;
    case "dependant":
      return <DependantParticulars {...comp} {...props} />;
    case "femaleSection":
      return <FemaleSection {...comp} {...props} />;
    case "medicalHistory":
      return <MedicalHistory {...comp} {...props} />;
    case "grid":
      return <Grid {...comp} prefix={prefix} {...props} />;
    case "questions":
      return <Questions {...comp} {...props} />;
    case "question":
      return <Question {...comp} {...props} />;
    case "html":
      return (
        <div
          dangerouslySetInnerHTML={{
            // eslint-disable-next-line xss/no-mixed-html
            __html: comp.content,
          }}
        />
      );
    default:
      return "";
  }
};

HDFComponent.propTypes = {
  label: PropTypes.string,
  prefix: PropTypes.string,
  name: PropTypes.string,
  comp: PropTypes.object.isRequired,
};

export default HDFComponent;



// WEBPACK FOOTER //
// ./components/employee/gen-hdf-form/components/HDFComponent.js